import { render, staticRenderFns } from "./LBSShelf.vue?vue&type=template&id=3a1099d2&scoped=true&"
import script from "./LBSShelf.vue?vue&type=script&lang=js&"
export * from "./LBSShelf.vue?vue&type=script&lang=js&"
import style0 from "./LBSShelf.vue?vue&type=style&index=0&id=3a1099d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1099d2",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VDataTable,VDialog,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/-36BVGaF/0/applicationg/aims-dashboard/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a1099d2')) {
      api.createRecord('3a1099d2', component.options)
    } else {
      api.reload('3a1099d2', component.options)
    }
    module.hot.accept("./LBSShelf.vue?vue&type=template&id=3a1099d2&scoped=true&", function () {
      api.rerender('3a1099d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Multifunction/lbs/LBSShelf.vue"
export default component.exports